// Modules/extensions/CanonicalPagination/JavaScript/CanonicalPagination.js
define('Ames.CanonicalOverride.CanonicalOverride.View', ['Facets.Browse.View', 'underscore'], function (
  FacetsBrowseView,
  _
) {
  'use strict';

  _.extend(FacetsBrowseView.prototype, {
    // Canonicalize every paginated PLP/search page to the page-1 URL.
    getCanonical: function getCanonical() {
      return this.getPath();
    }

    // Optional: with canonical pinned to page 1, the rel=prev/next tags are now
    // a slightly inconsistent signal. Google ignores them so they're harmless,
    // but if you want one coherent signal, null them out too:
    // , getRelPrev: function () { return null; }
    // , getRelNext: function () { return null; }
  });

  return { mountToApp: function mountToApp() {} };
});
